import { render, staticRenderFns } from "./SupportTicketSidebar.vue?vue&type=template&id=63f3363c&"
import script from "./SupportTicketSidebar.vue?vue&type=script&lang=js&"
export * from "./SupportTicketSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports